import {m} from 'framer-motion';
import {createElementTransform, getIntents} from '@sail/engine';
import type * as React from 'react';
import type {View} from '@sail/engine';
import {createMotionProps} from './createMotionProps';

const intrinsicCache = new Map<string, React.ComponentType>();
const componentCache = new WeakMap<React.ComponentType, React.ComponentType>();

export const runMotionIntents = createElementTransform(
  <Props>(revision: View.MutableViewRevision<Props>) => {
    const motionProps = getIntents(createMotionProps, revision);
    if (!motionProps) {
      return;
    }

    const Component = revision.Component;
    const cache = (
      typeof Component === 'string' ? intrinsicCache : componentCache
    ) as Map<string | React.ComponentType<Props>, React.ComponentType>;

    // @ts-expect-error - Error due to React 18
    let MotionComponent = cache.get(Component);
    if (!MotionComponent) {
      type MotionProps = Props extends {} ? Props : {};

      MotionComponent = m.create<MotionProps>(
        Component as React.ComponentType<React.PropsWithChildren<MotionProps>>,
      ) as unknown as React.ComponentType;

      // @ts-expect-error - Error due to React 18
      cache.set(Component, MotionComponent);
    }

    // @ts-expect-error - Error due to React 18
    revision.Component = MotionComponent as React.ComponentType<Props>;

    Object.assign(revision.props as object, motionProps as object);
  },
);
